.OptionItem {
  display: flex;
  width: 100%;
  height: 3.2rem;
  gap: 0.8rem;
  align-items: center;
}

.OptionDrag {
  cursor: grab;
  width: 1.6rem;
  height: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-grayscale-manatee);

  &:active {
    cursor: grabbing;
  }

  svg {
    width: 6.66px;
    height: 10.93px;
  }
}

.OptionContent {
  flex-grow: 1;
}

.OptionActions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: auto;
}
